import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import AudioControls from "../audio/SimpleAudioController";
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as appHelper from '../../../helpers/appHelper';
import * as appConstants from '../../../constants/appConstants';
import * as objectConstants from '../../../constants/objectConstants';
import * as animationHelper from "../../../helpers/animationHelper";

class LearnerSpeak extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            lang: this.props.lang,
            locale: appHelper.getLocalData(this.props.dialog),
            asset: {
                src: ""
            },
            audio: {
                src: ""
            },
            hasAudio: false,
            readyAudio: false,
            audioComplete: false,
            renderComplete: false,
            learning_speech_bubble_label: appHelper.getLocaleString("learning_speech_bubble_label"),
            you_label: appHelper.getLocaleString("you_label"),
            speaking_label: appHelper.getLocaleString("speaking_label"),
            dialogAudio: props.dialogAudio,
            screenObject: props.screenObject,
            allowAudioAutoPlay: true,
            showLabels: false,
            showAnimation: false,
        };

        this.showResponse = this.showResponse.bind(this);
        this.handleProgression = this.handleProgression.bind(this);
        this.setAssets = this.setAssets.bind(this);
        this.getImagePath = this.getImagePath.bind(this);
        this.onComplete = this.onComplete.bind(this);
        this.onPlayAudio = this.onPlayAudio.bind(this);
        this.onEndAudio = this.onEndAudio.bind(this);

        //Create Refs
        this.speachBubble = React.createRef();
        this.audioFile = React.createRef();
    }

    componentDidMount() {
        this.setAssets();
        this.showResponse();
    }

    componentWillReceiveProps(nextProps) {
        if (appHelper.isDefined(this.props.dialog.audio)) {
            this.setState({
                audio: Object.assign({}, appHelper.getAudioAsset(this.props.dialog.audio)),
                readyAudio: true,
                hasAudio: true,
            });

        }

        if (this.state.lang !== nextProps.lang) {
            this.setState({
                lang: nextProps.lang,
                locale: appHelper.getLocalData(this.props.dialog)
            });
        }
    }

    componentDidUpdate() {
        if (this.state.readyAudio) {
            this.onPlayAudio();
        }

        if (this.state.hasAudio && this.state.audioComplete && this.state.renderComplete) {
            this.handleProgression();
        }
    }

    setAssets() {

        if (appHelper.isDefined(this.props.dialog.image)) {
            this.setState({asset: Object.assign({}, appHelper.getLibraryImageAsset(this.props.dialog.image))});
        }
        if (appHelper.isDefined(this.props.dialog.audio)) {
            this.setState({
                audio: Object.assign({}, appHelper.getAudioAsset(this.props.dialog.audio)),
                readyAudio: true,
                hasAudio: true,
            });

        }
    }

    getImagePath(image) {
        if (appConstants.DEVELOPMENT_MODE) {
            if (appHelper.isDefined(image) && image.length > 0) {
                return require(`../../../../moveToDist/${image}`);
            }
        } else {
            return image;
        }
    }


    showResponse() {
        let objectRef = this.speachBubble.current;
        let params = {
            ele: objectRef,
            duration: objectConstants.SPEECH_BUBBLE_DURATION,
            delay: this.props.delay,
            callback: this.onComplete
        };
        animationHelper.showHeight(params);
    }

    onComplete() {
        this.setState({renderComplete: true});
        if (!this.state.hasAudio) {
            this.handleProgression();
        }
    }


    onPlayAudio() {
        this.setState({
            readyAudio: false
        });

        let videoRef = this.audioFile.current;
        alert(videoRef);
        if (appHelper.isDefined(videoRef)) {
            videoRef.play();
            let onEndAudio = this.onEndAudio;
            videoRef.onended = function () {
                onEndAudio();
            };
        }
    }

    onEndAudio() {
        this.setState({
            audioComplete: true
        });
    }

    handleProgression() {
        this.setState({renderComplete: false, audioComplete: false});
        this.props.callbacks.onObjectComplete(this.props.index);
    }

    render() {
        let customLearnerName = "";
        if(appHelper.isDefined(this.props.callbacks.checkLearnerDisplayName)){
            customLearnerName = this.props.callbacks.checkLearnerDisplayName();
        }
        let learnersName = this.state.you_label;

        if (this.props.trackingData.first_name.length > 0 && !this.props.trackingData.first_name.includes('Guest') && (!appHelper.isDefined(this.props.contentData.experience.learner_name_display_type) || (appHelper.isDefined(this.props.contentData.experience.learner_name_display_type) && this.props.contentData.experience.learner_name_display_type !== objectConstants.YOU))) {
            learnersName = this.props.trackingData.first_name;
        }

        if (customLearnerName.length > 0) {
            learnersName = customLearnerName;
        }
        return (
            <div className="a-c" ref={this.speachBubble}>
                <div className="object-container">
                    <div className="user_name_label">
                        <span className="hidden-el">{this.state.learning_speech_bubble_label}, </span>
                        <span>{learnersName}</span>
                        <span className="hidden-el"> {this.state.speaking_label},</span>
                    </div>
                    {appHelper.isDefined(this.state.locale.label)
                        ?
                        <div
                            className={`learner speak ${this.props.contentData.experience.speech_bubble_corner_style !== null ? this.props.contentData.experience.speech_bubble_corner_style : 'round'}`}>
                            <div className="dialog-content">
                                {
                                    appHelper.isDefined(this.state.screenObject) && appHelper.isDefined(this.state.screenObject.audio) && this.state.screenObject.audio.show_audio_controls && appHelper.isDefined(this.state.dialogAudio) && appHelper.isDefined(this.state.dialogAudio.id)
                                        ?

                                        <AudioControls audio={this.state.dialogAudio}
                                                       autoPlay={this.state.allowAudioAutoPlay}
                                                       showLabels={this.state.showLabels}
                                                       showAnimation={this.state.showAnimation}
                                                       themeType="light"
                                                       audioRef={`text_audio_${this.state.screenObject.asset_id}_${this.state.dialogAudio.id}_${this.state.dialogAudio.type}`}/>
                                        :
                                        null
                                }
                                <div dangerouslySetInnerHTML={{__html: this.state.locale.label}}/>
                            </div>
                        </div>
                        :
                        <div
                            className={`learner-conversation-image ${this.props.contentData.experience.speech_bubble_corner_style !== null ? this.props.contentData.experience.speech_bubble_corner_style : 'round'}`}>
                            <div className="dialog-content">
                                <img src={this.getImagePath(this.state.asset.src)} alt=""/>
                                {
                                    appHelper.isDefined(this.state.screenObject) && appHelper.isDefined(this.state.screenObject.audio) && this.state.screenObject.audio.show_audio_controls && appHelper.isDefined(this.state.dialogAudio) && appHelper.isDefined(this.state.dialogAudio.id)
                                        ?

                                        <AudioControls audio={this.state.dialogAudio}
                                                       autoPlay={this.state.allowAudioAutoPlay}
                                                       showLabels={this.state.showLabels}
                                                       showAnimation={this.state.showAnimation}
                                                       themeType="dark"
                                                       audioRef={`text_audio_${this.state.screenObject.asset_id}_${this.state.dialogAudio.id}_${this.state.dialogAudio.type}`}/>

                                        :
                                        null
                                }
                            </div>
                        </div>
                    }

                    {appHelper.isDefined(this.state.audio.src) && this.state.audio.src.length > 0
                        ?
                        <audio ref={this.audioFile} src={this.getImagePath(this.state.audio.src)}/>
                        :
                        null
                    }

                </div>
            </div>

        );
    }
}

LearnerSpeak.propTypes = {
    asset_id: PropTypes.number.isRequired,
    option_id: PropTypes.number,
    index: PropTypes.number.isRequired,
    dialog: PropTypes.object.isRequired,
    delay: PropTypes.number.isRequired,
    callbacks: PropTypes.object.isRequired,
    trackingData: PropTypes.object.isRequired,
    contentData: PropTypes.object.isRequired,
    lang: PropTypes.string.isRequired,
    screenObject: PropTypes.object,
    dialogAudio: PropTypes.object,
    actions: PropTypes.object
};

LearnerSpeak.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    let lang = state.userData.lang;
    return {
        lang: lang,
        trackingData: state.trackingData,
        contentData: state.contentData,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, trackingDataActions), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(LearnerSpeak);



/** WEBPACK FOOTER **
 ** ./src/components/objects/conversationDialog/LearnerSpeak.js
 **/